import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { removeDefaultParams } from '../../../Utils/helper';
import { ToolImage, Toollist, ToolName } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function ToolList(props) {
  const { data, screen } = props;
  let router = useRouter();
  const colors = ['#ff1a3c14', '#cf8bfc38', '#e150501f', '#5edf7026'];
  const toolClickHandler = (element) => {
    fireEvent({
      category: 'clicked_card_in_main_landing_page',
      screen_name: screen,
      card_name: element.name,
      deeplink_value: '/download-app',
      section_name: 'Tools',
    });
  };
  const getItems = () => {
    let item = [];
    data?.slice(0, 4)?.map((element, index) => {
      item.push(
        <Link
          href={{
            pathname: element.value,
            query: removeDefaultParams(router.query),
          }}
          passHref
        >
          <div key={index}>
            <Toollist
              color={colors[index]}
              onClick={() => toolClickHandler(element)}
            >
              <ToolImage src={element.image} alt="" />
            </Toollist>
            <ToolName>{element.name}</ToolName>
          </div>
        </Link>,
      );
    });
    return item;
  };

  return getItems();
}
